import http from "./http";

// 排行
var rank = {
  // 获取个人排行榜
  getUserRankList(params) {
    return new Promise((resolve) => {
      http.post("/v1/rank/query_kpi_user_rank_list", params).then((res) => {
        resolve(res);
      });
    });
  },
  // 获取品牌排行榜
  getBrandRankList(params) {
    return new Promise((resolve) => {
      http.post("/v1/rank/query_brand_rank_list", params).then((res) => {
        resolve(res);
      });
    });
  },
  // 获取军团列表
  getLegionList(params) {
    return new Promise((resolve) => {
      http.post("/v1/rank/category/list", params).then((res) => {
        resolve(res);
      });
    });
  },
  // 品牌明细
  getBrandDetails(params) {
    return new Promise((resolve) => {
      http.post("/v1/rank/query_brand_rank_detail", params).then((res) => {
        resolve(res);
      });
    });
  },
  // kpi全国联动
  getAllActData(params) {
    return new Promise((resolve) => {
      http.post("/v1/rank/query_all_act_data", params).then((res) => {
        resolve(res);
      });
    });
  },
  // 获取军团列表
  getGeneralList(params) {
    return new Promise((resolve) => {
      http.post("/v1/achievement/general/list", params).then((res) => {
        resolve(res);
      });
    });
  },
};
// 业绩
var achieve = {
  // 业绩：业绩界面
  getAchievementMenu() {
    return new Promise((resolve) => {
      http.post("/v1/achievement/query_kpi_user_detail").then((res) => {
        resolve(res);
      });
    });
  },
  // 查询我的客户列表
  getMyCustomerList(params) {
    return new Promise((resolve) => {
      http
        .post("/v1/achievement/query_customer_info_list", params)
        .then((res) => {
            resolve(res);
        });
    });
  },
  // 查询全部客户列表
  getAllCustomerList(params) {
    return new Promise((resolve) => {
      http
        .post("/v1/achievement/query_all_customer_info_list", params)
        .then((res) => {
            resolve(res);
        });
    });
  },
  // 查询我的/全部 客户订单列表
  getMyOrderList(params) {
    return new Promise((resolve) => {
      http
        .post("/v1/achievement/query_customer_order_list", params)
        .then((res) => {
            resolve(res);
        });
    });
  },
  // 军团列表
  getLegionList(params) {
    return new Promise((resolve) => {
      http.post("/v1/achievement/category/list", params).then((res) => {
        resolve(res);
      });
    });
  },
  // 品牌列表
  getRrandList(params) {
    return new Promise((resolve) => {
      http.post("/v1/achievement/brand/list", params).then((res) => {
        resolve(res);
      });
    });
  },
  // 门店列表
  getStoreList(params) {
    return new Promise((resolve) => {
      http.post("/v1/achievement/shop/list", params).then((res) => {
        resolve(res);
      });
    });
  },
  // 客户列表
  getStaffList(params) {
    return new Promise((resolve) => {
      http
        .post("/v1/achievement/guide/query_kpi_user_list", params)
        .then((res) => {
            resolve(res);
        });
    });
  },
  // 战区列表
  getGeneralRankList(params) {
    return new Promise((resolve) => {
      http.post("/v1/rank/query_general_rank_list", params).then((res) => {
        resolve(res);
      });
    });
  },
};
// 财务
var finance = {
  // 财务-用户账户信息
  getFinanceInfo() {
    return new Promise((resolve) => {
      http.post("/v1/finance/query_kpi_user_finance").then((res) => {
        if (res.code == 0||res.code == 10200) {
          resolve(res.data);
        } 
      });
    });
  },
  // 提现申请
  applyWithdraw(params) {
    return new Promise((resolve) => {
      http.post("/v1/finance/generate_finance_withdraw_record?amount="+params.amount,"",{
          "Content-Type": "application/x-www-form-urlencoded"
      }).then((res) => {
        resolve(res);
      });
    });
  },
  // kpi用户账户提现记录
  getWithdrawList() {
    return new Promise((resolve) => {
      http.post("/v1/finance/query_finance_withdraw_record").then((res) => {
        resolve(res);
      });
    });
  },
};
// 获取代金券核销记录
function getCardRecord(params) {
  return new Promise((resolve) => {
    http.post("/v1/kpiuser/card_record").then((res) => {
      resolve(res);
    });
  });
}

export default { rank, achieve, finance, getCardRecord };
